import HttpRequest from "../request";
import type { ICheckCodeParams, IForgetParams, ILoginParams, IRegistParams, contactForm } from "./types";
import type { Response } from "../request";
import { UserApi, CommonApi } from "../api";

export default {
    // login<T>(data: ILoginParams): Promise<Response<T>> {
    //     return HttpRequest.post(UserApi.login, data)
    // },
    // getUserInfo<T>(): Promise<Response<T>> {
    //     return HttpRequest.get(UserApi.getUserInfo, null)
    // },
    // getAccountRegist<T>(data: IRegistParams): Promise<Response<T>> {
    //     return HttpRequest.post(UserApi.getAccountRegist, data)
    // },
    // getAccountForget<T>(data: IForgetParams): Promise<Response<T>> {
    //     return HttpRequest.post(UserApi.getAccountForget, data)
    // },
    // getAccountEmailCode<T>(data: ICheckCodeParams): Promise<Response<T>> {
    //     return HttpRequest.post(UserApi.getAccountEmailCode, data)
    // },
    // getAccountGoogleLogin<T>(data :{code: string}): Promise<Response<T>> {
    //     return HttpRequest.get(UserApi.getAccountGoogleLogin, data)
    // },
    // getAccountLiunxDoLogin<T>(data :{code: string}): Promise<Response<T>> {
    //     return HttpRequest.get(UserApi.getAccountLiunxDoLogin, data)
    // },
    // getAccountAppleLogin<T>(data :{queryKey: string}): Promise<Response<T>> {
    //     return HttpRequest.get(UserApi.getAccountAppleLogin, data)
    // },
    // // getWxauthUrlApi<T>(data: ILoginParams): Promise<Response<T>> {
    // //     return HttpRequest.post(UserApi.getWxauthUrlApi, data)
    // // },
    // getWxauthCodeLoginApi<T>(data :{code: string}): Promise<Response<T>> {
    //     return HttpRequest.get(UserApi.getWxauthCodeLoginApi, data)
    // },
    // getQQauthCodeLoginApi<T>(data :{code: string}): Promise<Response<T>> {
    //     return HttpRequest.get(UserApi.getQQauthCodeLoginApi, data)
    // },
    // gettWitterCodeLoginApi<T>(data: {oauthToken: string, oauthVerifier: string}): Promise<Response<T>> {
    //     return HttpRequest.post(UserApi.gettWitterCodeLoginApi, data)
    // },
    // getTwitterOauthUrlApi<T>(): Promise<Response<T>> {
    //     return HttpRequest.get(UserApi.getTwitterOauthUrlApi, null)
    // },
    // getFacebookOauthlogin<T>(data: {inputToken: string}): Promise<Response<T>> {
    //     return HttpRequest.post(UserApi.getFacebookOauthlogin, data)
    // },
    // getLogout<T>(): Promise<Response<T>> {
    //     return HttpRequest.get(UserApi.getLogout, null)
    // },
    // getRequestConfigById<T>(data: {thisId: string}): Promise<Response<T>> {
    //     return HttpRequest.get(UserApi.getRequestConfigById, data)
    // },
    // getModifyCompareCfgApi<T>(data: {compareStyleType: number}): Promise<Response<T>> {
    //     return HttpRequest.post(UserApi.getModifyCompareCfgApi, data)
    // },
    // getAccountInfoEdit<T>(data: any): Promise<Response<T>> {
    //     return HttpRequest.post(UserApi.getAccountInfoEdit, data)
    // },
    // getDeleteAccount<T>(): Promise<Response<T>> {
    //     return HttpRequest.post(UserApi.getDeleteAccount, null)
    // },
    getContact<T>(params:contactForm): Promise<Response<T>> {
        return HttpRequest.post<T>(CommonApi.getContactApi, params) as Promise<Response<T>>
    },

}